import React, { useState, useContext, useEffect } from "react";
import { Routes, Route, Navigate, useNavigate } from "react-router-dom";
import OnboardingSteps from "components/onboardingSteps";
import Step1 from "components/onboardingSteps/Step1";
import Step2 from "components/onboardingSteps/Step2";
import Step3 from "components/onboardingSteps/Step3";
import Step4 from "components/onboardingSteps/Step4";
import Step5 from "components/onboardingSteps/Step5";
import Step6 from "components/onboardingSteps/Step6";
import ErrorAlert from "components/Alerts/ErrorAlert";
import { MobXProviderContext } from "mobx-react";

const OnboardingRoutes = () => {
  const { onboardingStore } = useContext(MobXProviderContext);
  const navigate = useNavigate();

  const [isVisible, setIsVisible] = useState(onboardingStore.error);
  const [errorMessage, setErrorMessage] = useState(
    onboardingStore.errorMessage
  );

  useEffect(() => {
    setIsVisible(onboardingStore.error);
    setErrorMessage(onboardingStore.errorMessage);
  }, [onboardingStore.error, onboardingStore.errorMessage]);

  const afterCloseCallBack = () => {
    onboardingStore.setErrorAlert(false, "");
    onboardingStore.fetchCuisineTypesData();
    navigate("/step5");
  };

  return (
    <>
      <ErrorAlert
        visible={isVisible}
        errorMessage={errorMessage}
        dismissAlert={afterCloseCallBack}
      />

      <Routes>
        <Route path="/" element={<Navigate to="/step1" />} />
        <Route path="*" element={<Navigate to="/step1" />} />

        <Route
          path="/step1"
          element={
            <OnboardingSteps>
              <Step1 />
            </OnboardingSteps>
          }
        />
        <Route
          path="/step2"
          element={
            <OnboardingSteps>
              <Step2 />
            </OnboardingSteps>
          }
        />
        <Route
          path="/step3"
          element={
            <OnboardingSteps>
              <Step3 />
            </OnboardingSteps>
          }
        />
        <Route
          path="/step4"
          element={
            <OnboardingSteps>
              <Step4 />
            </OnboardingSteps>
          }
        />
        <Route
          path="/step5"
          element={
            <OnboardingSteps>
              <Step5 />
            </OnboardingSteps>
          }
        />

        <Route
          path="/step6"
          element={
            <OnboardingSteps>
              <Step6 />
            </OnboardingSteps>
          }
        />
      </Routes>
    </>
  );
};

export default OnboardingRoutes;
